module.exports = __webpack_public_path__ + "img/danni-fisher-shin-lone-warrior.92031b6.jpg";